import React from 'react';

import type { NodeViewDecorator } from './../../../../ricos-types/index.js';

export const BreakoutDecorator: NodeViewDecorator<JSX.Element> = {
  rule: () => true,
  decorate: ({ node, element, isRoot, context }) => {
    if (!isRoot) {
      return <>{element}</>;
    }
    const breakoutSettings = context.theme.breakout;
    if (!breakoutSettings) {
      return <>{element}</>;
    }
    const breakout = breakoutSettings.rule({ node });
    return <div {...{ 'data-breakout': breakout }}>{element}</div>;
  },
};
